<div class="op-mobile-page">
  <div class="op-mobile-header">
    <mobile-page-header [closeableView]="true"
                        [fillBackground]="fillBackground"
                        (onClose)="onClose.emit()">
      <h4 class="m-0" [innerHTML]="'cart.mobile.title' | translate: {count: count}"></h4>
    </mobile-page-header>

    <ui-rounded-panel [fillBackground]="fillBackground"></ui-rounded-panel>
  </div>

  <div class="op-mobile-content-container bg-white">
    <div class="container rounded-panel-compensator">
      <ng-container *ngFor="let line of orderLines">
        <mobile-cart-product-item
          class="mobile-cart-line-row"
          *ngIf="!line.details?.applyOnce"
          [orderLine]="line"
          [orderLines]="orderLines"
          [currency]="currency"
          (onEdit)="editOrderLine(line)"
          (onRemoveOrderLine)="removeProduct($event)"
          (onCountUpdate)="countUpdated($event, line)"
        ></mobile-cart-product-item>

        <mobile-cart-apply-once-item
          class="mobile-cart-line-row"
          *ngIf="line.details?.applyOnce"
          [orderLine]="line"
          [currency]="currency"
          (onRemoveOrderLine)="removeProduct($event)"
        ></mobile-cart-apply-once-item>
      </ng-container>

      <div class="mobile-cart-info-row d-flex justify-content-between"
           *ngIf="cart.invoiceFee">
        <div [translate]="'cart.invoiceFee'">Invoice fee</div>
        <div>{{ cart.invoiceFee | currencyFormat: currency }}</div>
      </div>

      <div class="mobile-cart-info-row d-flex justify-content-between"
           *ngIf="delivery?.type === DELIVERY_OPTIONS.DELIVERY">
        <div [translate]="'receipt.delivery'">Delivery</div>
        <div>{{ deliveryPrice | currencyFormat: currency }}</div>
      </div>

      <div class="mobile-cart-info-row d-flex justify-content-between"
           *ngIf="cart.discountedPrice">
        <div [translate]="'receipt.discount'">Discount</div>
        <div>-&nbsp;{{ cart.discountedPrice | currencyFormat: currency }}</div>
      </div>

    </div>
  </div>

  <mobile-cart-footer
    [total]="total"
    [currency]="currency"
    [delivery]="delivery"
    [deliveryType]="cart?.uiDeliveryType"
    (onClear)="onClear.emit()"
    (onShopMore)="onAddMoreClick.emit()"
    (onCheckout)="onContinue.emit()"
    (onDeliveryEdit)="onDeliveryEdit.emit()"
  ></mobile-cart-footer>
</div>

